// media-api.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType, HttpHeaders } from '@angular/common/http';
import { ApiUrlService } from '@app/core/services/common/api-url.service';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ContentApiService } from './content-api.service';

export interface MediaResponse {
  id?: string;
  url?: string;
  [key: string]: any;
}

/**
 * Serwis odpowiedzialny za operacje multimedialne poprzez API
 * Specjalizacja dla przesyłania i zarządzania plikami multimedialnymi
 */
@Injectable({
  providedIn: 'root'
})
export class ContentMediaApiService {
  private readonly apiUrl = this.apiUrlService.getApiUrl() + 'client/creator/media';
  private readonly token = localStorage.getItem('adminAuthToken') ?? '';

  constructor(
    private http: HttpClient,
    private apiUrlService: ApiUrlService,
    private apiService: ContentApiService
  ) { }

  /**
    * Wysyła zdjęcie
    * @param file
    * @param onProgress
    * @returns
    */
  uploadImage(
    file: File,
    opts: {
      excludeGlobalLoader?: boolean;
      includePhotosLoader?: boolean;
      isBanner?: boolean;
    } = {},
    onProgress?: (percent: number) => void
  ): Observable<MediaResponse> {
    const formData = new FormData();
    formData.append('file', file);
    formData.forEach((v, k) => console.log(k, v));

    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.token}`);

    return this.http.post<MediaResponse>(this.apiUrl, formData, {
      headers,
      reportProgress: true,
      observe: 'events',
    }).pipe(
      tap((event: HttpEvent<MediaResponse>) => {
        if (event.type === HttpEventType.UploadProgress && onProgress) {
          const percent = Math.round((event.loaded / (event.total ?? 1)) * 100);
          onProgress(percent);
        }
      }),
      map(event => {
        if (event.type === HttpEventType.Response) {
          return event.body as MediaResponse;
        }
        console.log('[ContentMediaApiService->uploadImage] event', event);
        return event;
      }),
      catchError(error => {
        this.apiService.redirectIfForbidden(error);
        return throwError(() => error);
      })

    );
  }
}
